import { withInstall } from '@hongluan-ui/utils'
import Select from './src/select.vue'

export const HlSelect = withInstall(Select)
export default HlSelect

export * from './src/token'
